<template>
  <b-container class="highlight-container">
    <!-- <router-link to="/"><i class="fas fa-times btn--close"></i></router-link> -->
    <router-link :to="`/${form.sourceQuery}`"><i class="fas fa-times btn--close"></i></router-link>
    <b-img rc="/img/icons/community-title.svg" class="community-logo" />
    <b-row>
      <b-col md="12" class="text-center px-0">
        <h2 class="text--extrabold mb-10 flexFont">Built From The Ground Up</h2>
        <p v-scroll-reveal>
          At New Seaton, we have that new home feeling throughout
          <br class="d-none d-md-block" />
          our whole community. Every detail of this community has been planned
          <br class="d-none d-sm-block" />
          to make your life easier.
        </p>

        <div class="image-wrapper" v-scroll-reveal="{ delay: 150 }">
          <b-img
            src="/img/white-spacer.png"
            fluid
            center
            alt="New Seaton Parks"
          />
        </div>
      </b-col>
    </b-row>

    <div class="home-container">
      <b-row class="site-logo" v-scroll-reveal="{ delay: 150 }">
        <b-col md="8" class="mb-2">
          <b-img src="/img/towerhill-logo.png" fluid alt="Tower HIll" />
        </b-col>
        <b-col md="4" sm="6" class="text-center">
          <br />
          <h4>View other builders</h4>
          <button class="black-button">
            <nuxt-link to="/aspenridgeHomes">
            <!-- <nuxt-link :to="`/aspenridgeHomes${form.sourceQuery}`"> -->
              <b-img
                class="black-button-img"
                src="/img/icons/button-logo-aspenridge.png"
                fluid
                alt="Aspen Ridge"
              />
            </nuxt-link>
          </button>

          <button class="black-button">
            <nuxt-link to="/brookfieldHomes">
            <!-- <nuxt-link :to="`/brookfieldHomes${form.sourceQuery}`"> -->
              <b-img
                class="black-button-img"
                src="/img/icons/button-logo-brookfield.png"
                fluid
                alt="Brookfield Residential"
              />
            </nuxt-link>
          </button>
        </b-col>
      </b-row>

      <!-- First House Section -->
      <b-row class="background--white pb-30">
        <b-col md="10" offset-md="1" class="text-center">
          <b-row>
            <h2 class="home-container-title purple">Townhomes</h2>
            <b-col
              v-for="home in towerhill20"
              :key="home.homeTitle"
              xl="4"
              md="6"
              lg="6"
              sm="6"
              class="my-2 px-2 home-photo"
            >
              <a target="_blank" :href="home.homeSitePlanPDF">
                <b-img :src="home.homePhoto" fluid :alt="home.homeTitle"/>
                <div class="home-info purple">
                  <div>
                    <h1>{{ home.homeTitle }}</h1>
                    <p>
                      <span
                        v-for="elevation in home.homeElevation"
                        :key="elevation"
                      >
                        {{ elevation }}
                      </span>
                    </p>
                  </div>
                  <div>
                    <b-img src="/img/icons/area.png" width="30" alt="Area Icon" />
                  </div>
                </div>
              </a>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <!-- Laneway Towns -->
      <b-row class="background--white pb-30">
        <b-col md="10" offset-md="1" class="text-center">
          <b-row>
            <h2 class="home-container-title lightblue">Laneway Townhomes</h2>
            <b-col
              v-for="home in towerhillLaneway"
              :key="home.homeTitle"
              xl="4"
              md="6"
              lg="6"
              sm="6"
              class="my-2 px-2 home-photo"
            >
              <a target="_blank" :href="home.homeSitePlanPDF">
                <b-img :src="home.homePhoto" fluid :alt="home.homeTitle"/>
                <div class="home-info lightblue">
                  <div>
                    <h1>{{ home.homeTitle }}</h1>
                    <p>
                      <span
                        v-for="elevation in home.homeElevation"
                        :key="elevation"
                      >
                        {{ elevation }}
                      </span>
                    </p>
                  </div>
                  <div>
                    <b-img src="/img/icons/area.png" width="30" alt="Area Icon"/>
                  </div>
                </div>
              </a>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

    <!-- Live/Work Towns -->
      <b-row class="background--white pb-30">
        <b-col md="10" offset-md="1" class="text-center">
          <b-row>
            <h2 class="home-container-title gold">Live/Work Townhomes</h2>
            <b-col
              v-for="home in liveworkTownhomes"
              :key="home.homeTitle"
              xl="4"
              md="6"
              lg="6"
              sm="6"
              class="my-2 px-2 home-photo"
            >
              <a target="_blank" :href="home.homeSitePlanPDF">
                <b-img :src="home.homePhoto" fluid :alt="home.homeTitle"/>
                <div class="home-info gold">
                  <div>
                    <h1>{{ home.homeTitle }}</h1>
                    <p>
                      <span
                        v-for="elevation in home.homeElevation"
                        :key="elevation"
                      >
                        {{ elevation }}
                      </span>
                    </p>
                  </div>
                  <div>
                    <b-img src="/img/icons/area.png" width="30" alt="Area Icon" />
                  </div>
                </div>
              </a>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <!-- Second House Selection -->
      <b-row class="background--white pb-30" id="towerHill-30s">
        <b-col md="10" offset-md="1" class="text-center">
          <b-row>
            <h2 class="home-container-title yellow">30' Detached</h2>
            <b-col
              v-for="home in towerhill30"
              :key="home.homeTitle"
              xl="4"
              md="6"
              lg="6"
              sm="6"
              class="my-2 px-2 home-photo"
            >
              <a target="_blank" :href="home.homeSitePlanPDF">
                <b-img :src="home.homePhoto" fluid :alt="home.homeTitle"/>
                <div class="home-info yellow">
                  <div>
                    <h1>{{ home.homeTitle }}</h1>
                    <p>
                      <span
                        v-for="elevation in home.homeElevation"
                        :key="elevation"
                      >
                        {{ elevation }}
                      </span>
                    </p>
                  </div>
                  <div>
                    <b-img src="/img/icons/area.png" width="30" alt="Area Icon" />
                  </div>
                </div>
              </a>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- Third House Selection -->
      <b-row class="background--white pb-30" id="towerHill-36s">
        <b-col md="10" offset-md="1" class="text-center">
          <b-row>
            <h2 class="home-container-title orange">36' Detached</h2>
            <b-col
              v-for="home in towerhill36"
              :key="home.homeTitle"
              xl="4"
              md="6"
              lg="6"
              sm="6"
              class="my-2 px-2 home-photo"
            >
              <a target="_blank" :href="home.homeSitePlanPDF">
                <b-img :src="home.homePhoto" fluid :alt="home.homeTitle"/>
                <div class="home-info orange">
                  <div>
                    <h1>{{ home.homeTitle }}</h1>
                    <p>
                      <span
                        v-for="elevation in home.homeElevation"
                        :key="elevation"
                      >
                        {{ elevation }}
                      </span>
                    </p>
                  </div>
                  <div>
                    <b-img src="/img/icons/area.png" width="30" alt="Area Icon"  />
                  </div>
                </div>
              </a>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- Fourth House Selection -->
      <b-row class="background--white pb-30" id="towerHill-43s">
        <b-col md="10" offset-md="1" class="text-center">
          <b-row>
            <h2 class="home-container-title blue">43' Detached</h2>
            <b-col
              v-for="home in towerhill43"
              :key="home.homeTitle"
              xl="4"
              md="6"
              lg="6"
              sm="6"
              class="my-2 px-2 home-photo"
            >
              <a target="_blank" :href="home.homeSitePlanPDF">
                <b-img :src="home.homePhoto" fluid :alt="home.homeTitle"/>
                <div class="home-info green">
                  <div>
                    <h1>{{ home.homeTitle }}</h1>
                    <p>
                      <span
                        v-for="elevation in home.homeElevation"
                        :key="elevation"
                      >
                        {{ elevation }}
                      </span>
                    </p>
                  </div>
                  <div>
                    <b-img src="/img/icons/area.png" width="30" alt="Area Icon" />
                  </div>
                </div>
              </a>
            </b-col>
          </b-row>
          <!-- <br><br>
                    <highlight-footer /> -->
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
//   import highlightFooter from '@/components/HighlightFooter';
export default {
  // components: {
  //   highlightFooter
  // },
  data() {
    return {
      towerhill20: [
        {
          homeTitle: "Cedar",
          homeElevation: ["elev a 1573 sq ft. | ", "elev b 1573 sq ft."],
          homePhoto: "/img/houses/cedar.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/cedar-min.pdf",
        },
        {
          homeTitle: "Birch",
          homeElevation: ["elev a 1664 sq ft. | ", "elev b 1664 sq ft."],
          homePhoto: "/img/houses/birch.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/birch-min.pdf",
        },
        {
          homeTitle: "Hickory",
          homeElevation: ["elev a 1725 sq ft. | ", "elev b 1725 sq ft."],
          homePhoto: "/img/houses/hickory.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/hickory-min.pdf",
        },
        {
          homeTitle: "Chestnut",
          homeElevation: ["elev a 1843 sq ft. | ", "elev b 1843 sq ft."],
          homePhoto: "/img/houses/chestnut.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/chestnut-min.pdf",
        },
        {
          homeTitle: "Beech",
          homeElevation: ["elev a 1937 sq ft. | ", "elev b 1937 sq ft."],
          homePhoto: "/img/houses/beech.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/beech-min.pdf",
        },
        {
          homeTitle: "Maple",
          homeElevation: ["elev a 2028 sq ft. | ", "elev b 2028 sq ft."],
          homePhoto: "/img/houses/maple.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/maple-min.pdf",
        },
        {
          homeTitle: "Maple (Mod)",
          homeElevation: ["elev a 2034 sq ft."],
          homePhoto: "/img/houses/maple(mod).jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/maple(mod)-min.pdf",
        },
        {
          homeTitle: "Willow",
          homeElevation: ["elev a 1891 sq ft."],
          homePhoto: "/img/houses/willow.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/willow-min.pdf",
        },
        {
          homeTitle: "Juniper",
          homeElevation: ["elev a 2036 sq ft."],
          homePhoto: "/img/houses/juniper.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/juniper-min.pdf",
        },
        {
          homeTitle: "Hawthorne",
          homeElevation: ["elev b 1762 sq ft."],
          homePhoto: "/img/houses/hawthorne.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/hawthorne-min.pdf",
        },
        {
          homeTitle: "Balsam",
          homeElevation: ["elev b 1836 sq ft."],
          homePhoto: "/img/houses/balsam.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/balsam-min.pdf",
        },
      ],
      towerhillLaneway: [
        {
          homeTitle: "Camden",
          homeElevation: ["elev a 2571 sq ft."],
          homePhoto: "/img/houses/camden.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/camden-min.pdf",
        },
        {
          homeTitle: "Norfolk",
          homeElevation: ["elev a 2012 sq ft."],
          homePhoto: "/img/houses/norfolk.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/norfolk-min.pdf",
        },
        {
          homeTitle: "Wellington",
          homeElevation: ["elev a 2738 sq ft."],
          homePhoto: "/img/houses/wellington.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/wellington-min.pdf",
        },
        {
          homeTitle: "Winslow",
          homeElevation: ["elev a 1786 sq ft."],
          homePhoto: "/img/houses/winslow.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/winslow-min.pdf",
        },
      ],
      liveworkTownhomes: [
        {
          homeTitle: "BAYFIELD-LW",
          homeElevation: ["elev a 2086 sq ft."],
          homePhoto: "/img/houses/BAYFIELD-LW.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/BAYFIELD-LW.pdf",
        },
        {
          homeTitle: "FAIRVIEW-LW",
          homeElevation: ["elev a 2092 sq ft."],
          homePhoto: "/img/houses/FAIRVIEW-LW.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/FAIRVIEW-LW.pdf",
        },
        {
          homeTitle: "ASHFORD-LW",
          homeElevation: ["elev a 2230 sq ft."],
          homePhoto: "/img/houses/ASHFORD-LW.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/ASHFORD-LW.pdf",
        },
      ],
      towerhill30: [
        {
          homeTitle: "Bruce",
          homeElevation: [
            "elev a 2019 sq ft. | ",
            "elev b 2019 sq ft. | ",
            "elev c 2019 sq ft.",
          ],
          homePhoto: "/img/houses/bruce.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/bruce-min.pdf",
        },
        {
          homeTitle: "Cedarville",
          homeElevation: [
            "elev a 2128 sq ft. | ",
            "elev b 2128 sq ft. | ",
            "elev c 2128 sq ft.",
          ],
          homePhoto: "/img/houses/cedarville.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/cedarville-min.pdf",
        },
        {
          homeTitle: "Edwards",
          homeElevation: [
            "elev a 2151 sq ft. | ",
            "elev b 2151 sq ft. | ",
            "elev c 2151 sq ft.",
          ],
          homePhoto: "/img/houses/edwards.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/edwards-min.pdf",
        },
        {
          homeTitle: "Thompson",
          homeElevation: [
            "elev a 2374 sq ft. | ",
            "elev b 2374 sq ft. | ",
            "elev c 2355 sq ft.",
          ],
          homePhoto: "/img/houses/thompson.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/thompson-min.pdf",
        },
      ],
      towerhill36: [
        {
          homeTitle: "Maynard",
          homeElevation: [
            "elev a 1859 sq ft. | ",
            "elev b 1857 sq ft. | ",
            "elev c 1867 sq ft.",
          ],
          homePhoto: "/img/houses/maynard.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/maynard-min.pdf",
        },
        {
          homeTitle: "Cameron",
          homeElevation: [
            "elev a 2206 sq ft. | ",
            "elev b 2210 sq ft. | ",
            "elev c 2210 sq ft.",
          ],
          homePhoto: "/img/houses/cameron.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/cameron-min.pdf",
        },
        {
          homeTitle: "Lambton",
          homeElevation: [
            "elev a 2309 sq ft. | ",
            "elev b 2307 sq ft. | ",
            "elev c 2316 sq ft.",
          ],
          homePhoto: "/img/houses/lambton.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/lambton-min.pdf",
        },
        {
          homeTitle: "Simcoe",
          homeElevation: [
            "elev a 2310 sq ft. | ",
            "elev b 2292 sq ft. | ",
            "elev c 2306 sq ft.",
          ],
          homePhoto: "/img/houses/simcoe.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/simcoe-min.pdf",
        },
        {
          homeTitle: "Dalhousie",
          homeElevation: [
            "elev a 2426 sq ft. | ",
            "elev b 2426 sq ft. | ",
            "elev c 2426 sq ft.",
          ],
          homePhoto: "/img/houses/dalhousie.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/dalhousie-min.pdf",
        },
        {
          homeTitle: "Fairbank",
          homeElevation: [
            "elev a 2477 sq ft. | ",
            "elev b 2479 sq ft. | ",
            "elev c 2478 sq ft.",
          ],
          homePhoto: "/img/houses/fairbank.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/fairbank-min.pdf",
        },
        {
          homeTitle: "Crawford",
          homeElevation: [
            "elev a 2620 sq ft. | ",
            "elev b 2615 sq ft. | ",
            "elev c 2632 sq ft.",
          ],
          homePhoto: "/img/houses/crawford.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/crawford-min.pdf",
        },
        {
          homeTitle: "Windigo",
          homeElevation: [
            "elev a 2766 sq ft. | ",
            "elev b 2766 sq ft. | ",
            "elev c 2765 sq ft.",
          ],
          homePhoto: "/img/houses/windigo.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/windigo-min.pdf",
        },
        {
          homeTitle: "Beaumont",
          homeElevation: [
            "elev a 2944 sq ft. | ",
            "elev b 2886 sq ft. | ",
            "elev c 2954 sq ft.",
          ],
          homePhoto: "/img/houses/beaumont.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/beaumont-min.pdf",
        },
      ],
      towerhill43: [
        {
          homeTitle: "Centennial",
          homeElevation: [
            "elev a 3270 sq ft. | ",
            "elev b 3281 sq ft. | ",
            "elev c 3262 sq ft.",
          ],
          homePhoto: "/img/houses/centennial.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/centennial-min.pdf",
        },
        {
          homeTitle: "Killarney",
          homeElevation: [
            "elev a 3434 sq ft. | ",
            "elev b 3438 sq ft. | ",
            "elev c 3439 sq ft.",
          ],
          homePhoto: "/img/houses/killarney.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/killarney-min.pdf",
        },
        {
          homeTitle: "Trillium",
          homeElevation: [
            "elev a 3537 sq ft. | ",
            "elev b 3541 sq ft. | ",
            "elev c 3564 sq ft.",
          ],
          homePhoto: "/img/houses/trillium.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/trillium-min.pdf",
        },
        {
          homeTitle: "Jasper",
          homeElevation: [
            "elev a 3412 sq ft. | ",
            "elev b 3361 sq ft. | ",
            "elev c 3440 sq ft.",
          ],
          homePhoto: "/img/houses/jasper.jpg",
          homeSitePlanPDF: "/files/towerhill-siteplan/jasper-min.pdf",
        },
      ],
      form: {
          sourceQuery:""
      }
    };
  },
  mounted() {
    this.$root.layout.methods.triggerViewPortAnimation();
    this.getPageQuery();
  },
  methods: {
    getPageQuery() {
        this.form.sourceQuery = localStorage.getItem("sourceQuery");
    }
  },
  transition: {
    mode: "out-in",
    css: false,
    appear: true,
    enter(el, done) {
      done();
    },
    leave(el, done) {
      done();
    },
  },
};
</script>

<style>
</style>